import React, { createContext, useContext, useEffect, useState } from 'react'
import { getDatabase, ref, onValue, child } from 'firebase/database'
import { databaseUrl, firebaseApp } from 'firebaseConfig'
import { useAppSelector } from 'reduxStore/store'

type IHealthStatusData = {
  title?: string | null
}

const HealthStatusListenerContext = createContext<IHealthStatusData>({})

const HealthStatusListenerProvider: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const [healthStatus, setHealthStatus] = useState<IHealthStatusData>({})
  const establishmentId = useAppSelector(
    state => state.establishment.data?.establishment_id
  )

  useEffect(() => {
    // If no establishment ID, clear the health status
    if (!establishmentId) {
      setHealthStatus({})
      return
    }

    const db = ref(getDatabase(firebaseApp(), databaseUrl()))
    const healthStatusRef = child(db, `health_status_check/${establishmentId}`)

    const unsubscribe = onValue(healthStatusRef, snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val()
        // Only set title if it exists and is not empty
        setHealthStatus({
          title: data?.title && data.title.trim() !== '' ? data.title : null
        })
      } else {
        // No document exists, clear the health status
        setHealthStatus({})
      }
    })

    return () => {
      unsubscribe()
    }
  }, [establishmentId])

  return (
    <HealthStatusListenerContext.Provider value={healthStatus}>
      {children}
    </HealthStatusListenerContext.Provider>
  )
}

export function useHealthStatusListener() {
  return useContext(HealthStatusListenerContext)
}

export default HealthStatusListenerProvider
